enum Facets {
    ART_SUBJECT_ID = 'artSubject',
    AUCTION_HOUSE_ID = 'auctionHouse',
    // Typeahead-only facet emitted by search-party when
    // Parameters.facetOverrides.auctionHouse.searchString is set. Distinct
    // from AUCTION_HOUSE_ID so the FE can render the typeahead dropdown
    // without merging it into the regular AuctionHouse bucket list (which
    // keys on House.ID, not House.Name).
    AUCTION_HOUSE_NAME_ID = 'auctionHouseName',
    AUDIO_VIDEO = 'audioVideo',
    BUYERS_PREMIUM_ID = 'hasBuyersPremium',
    CATEGORY_ID = 'F1',
    COUNTRY_CODE_ID = 'countryCode',
    CREATOR_ID = 'creator',
    CURRENCY_ID = 'currency',
    CURRENT_BID_ID = 'currentBid',
    DISTANCE_ID = 'distance',
    ESTIMATED_PRICE_ID = 'estimate',
    HAMMER_PRICE_ID = 'hammerPrice',
    KEYWORD_ID = 'keyword',
    LOCATION_ID = 'location',
    MATERIALS_AND_TECHNIQUES_ID = 'materialsAndTechniques',
    ORIGIN_ID = 'F2',
    PAYMENT = 'payment',
    REGION_ID = 'region',
    RESERVE = 'reserve',
    SALE_START = 'saleStart',
    SALE_TYPE_ID = 'sale_type',
    SHIPPING = 'shipping',
    STATE_ID = 'state',
    STYLE_PERIOD_ID = 'stylePeriod',
    TOP_RATED_ID = 'topRated',
}

const KNOWN_FACET_VALUES = new Set<string>(Object.values(Facets));

// Returns true for any facet ID that isn't a hardcoded known facet.
// This covers Attrs.* facets (subject, etc.) that are dynamically returned by the API.
export const isUnknownDynamicFacet = (id: string): boolean => !KNOWN_FACET_VALUES.has(id);

export default Facets;
